var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-5",attrs:{"flat":""}},[_c('v-alert',{attrs:{"icon":"mdi-shield-lock-outline","prominent":"","text":"","type":"info"}},[_vm._v(" Necesitas permisos para acceder a este recurso. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }